import { useCallback, useState } from "react";
import { userIsPublic } from "../../utils/roles";
import { getRedirectToRegisterPage, redirectToUrl } from "../../utils/url/urlUtils";
import { trackSrpAddToWishlist } from "../../feature/Analytics/ga/ga";
import { type BaseProductData, type ProductData } from "../../models/ProductData";
import { type OptionalPartFormData } from "../../AddToCart/hooks/useAddToCartNew";
import { openAddToWishlistWizard } from "../../Wishlist/modal/AddToWishlist/AddToWishlistService";
import { mapOptionalParts4Wishlist } from "../../Wishlist/modal/AddToWishlist/utils";
import { getInitialPriceReference } from "~/AddToCart/redux/addToCart/getInitialPriceReference";

export interface UseAddProductToWishlistFlowParams {
  productInput?: ProductData;
  initialQuantity?: number;
  initialPriceReference?: string;
  selectedOptionalParts?: Dict<OptionalPartFormData>;
}

export const useAddProductToWishlistFlow = ({
  productInput,
  initialQuantity = 1,
  initialPriceReference = getInitialPriceReference(),
  selectedOptionalParts,
}: UseAddProductToWishlistFlowParams) => {
  // set a default product if it wasn't provided by productInput
  const [product, setProduct] = useState(productInput || { designation: "", code: "", isOptime: false });

  const onClick = useCallback(
    (productData?: BaseProductData) => {
      // set new product by click if available
      productData && setProduct(productData);

      const data = productData || product;

      if (userIsPublic()) {
        redirectToUrl(getRedirectToRegisterPage({ openLogin: true }));
      } else {
        trackSrpAddToWishlist(data.designation, 1);

        openAddToWishlistWizard({
          productCode: data.code,
          initialQuantity: initialQuantity,
          initialPriceReference: initialPriceReference,
          addTracking: (product) => trackSrpAddToWishlist(product.base.designation, 2),
          selectedOptionalParts: mapOptionalParts4Wishlist(data as ProductData, selectedOptionalParts),
        });
      }
    },
    [product.designation, initialPriceReference, initialQuantity],
  );

  const modal = false;

  return [onClick, modal] as const;
};
